import { Helmet } from "react-helmet";

function Seo() {
    const title = "Birthday Reminder App - Never Miss a Birthday Again!";
    const description =
        "Keep track of all your birthdays effortlessly with the Birthday Reminder app. Set personalized reminders, and celebrate special moments without missing a beat. Download now and make every birthday unforgettable!";
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta
                property="og:image"
                content={"https://birthday-reminder.instanceof.dev/static/media/feature_graphic.b485c484640cc4c3ba5c.png"}
            />
            <meta
                property="og:url"
                content="https://birthday-reminder.instanceof.dev"
            />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                name="twitter:url"
                content={"https://birthday-reminder.instanceof.dev/static/media/feature_graphic.b485c484640cc4c3ba5c.png"}
            />
            <meta name="twitter:card" content="summary" />
            <link
                rel="canonical"
                href="https://birthday-reminder.instanceof.dev"
            />
            <meta
                name="keywords"
                content="birthday,reminder,reminders,notification,download,application"
            />
        </Helmet>
    );
}

export default Seo;
